import {useEffect, useState} from 'react';
import {GlobalPosterEditorJqueryElement} from '@Components/poster-editor/poster-editor.types';
import {useAppSelector} from '@/hooks';

export function useIsPosterScrollableVertically(): boolean {
  const scale = useAppSelector((state) => {
    return state.posterEditor?.posterObject?.scaling.scale;
  });
  const [doesVerticalScrollExist, setDoesVerticalScrollExist] = useState(false);

  const checkIfScrolling = (): void => {
    const whiteboardContainer = window.posterEditor?.elements[GlobalPosterEditorJqueryElement.WHITEBOARD_CONTAINER]?.get(0);
    if (!whiteboardContainer) return;

    const doesScrollExist = whiteboardContainer.scrollHeight > whiteboardContainer.clientHeight;

    if ((doesVerticalScrollExist && !doesScrollExist) || (!doesVerticalScrollExist && doesScrollExist)) {
      setDoesVerticalScrollExist(doesScrollExist);
      return;
    }
  };

  useEffect((): void => {
    checkIfScrolling();
  }, [scale]);

  return doesVerticalScrollExist;
}
